import {Component} from '@angular/core';
import {CheckboxModule} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import {ButtonModule} from 'primeng/button';
import {Card} from 'primeng/card';
import {TranslateModule, TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-forwarding-settings-form',
  imports: [
    CheckboxModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    Card,
    TranslateModule,
  ],
  templateUrl: './forwarding-settings-form.component.html',
  styleUrl: './forwarding-settings-form.component.scss',
  standalone: true
})
export class ForwardingSettingsFormComponent {
  isForwardEnabled = false

  constructor(private translate: TranslateService) {}
}
